import WhereBuy from './WhereBuy';

export const whereBuy = {
  firstLevel:  WhereBuy,
  secondLevel: WhereBuy,
};